/* src/app/intern/intern-details/observations/mentor/mentor-assignment.component.scss */
.form {
  padding: 20px;
}
button {
  border-radius: 22px;
  width: 120px;
}
mat-fab {
  border-radius: initial;
}
.entity-name {
  font-weight: bolder;
}
.hidden {
  display: none;
}
.half-width {
  width: 48%;
}
.full-width {
  width: 96%;
}
mat-form-field {
  width: 100%;
  margin-bottom: 10px;
}
.narrow-field {
  width: 250px;
}
#saveButton {
  width: 130px;
}
.container {
  display: table;
  width: 100%;
}
label.inline {
  display: table-cell;
  width: 1px;
  white-space: nowrap;
}
span.inline {
  display: table-cell;
  padding: 0 4px 0 6px;
}
.action-buttons button {
  margin-left: 10px;
}
.dialog-content {
  overflow-y: visible !important;
  display: contents;
}
#confirmMessage {
  text-align: center;
  margin: 50px 0;
}
#confirmMessage button {
  margin-right: 25px;
}
/*# sourceMappingURL=mentor-assignment.component.css.map */
